import React from 'react';

import BaseComponentProperty from "../index";

export default class InfoTabs extends BaseComponentProperty {
    renderOwnProperties() {
        return (
            <div>
                <button className='button mb-2' onClick={() => {
                    let data = this.props.component.data;
                    let items = data.items;
                    items.push({
                        image: "",
                        image_alt: "",
                        name: "",
                        description: "",
                        information: ""
                    });
                    data.items = items;
                    this.props.onChange('data', data);
                }}>+
                </button>
                <div className='d-flex flex-row flex-wrap'>
                    {this.props.component.data.items.map((item, index) => {
                        return (
                            <div key={index} style={{position: 'relative'}}>
                                <i
                                    className='fas fa-trash text-danger clickable'
                                    style={{position: 'absolute', right: '-15px', top: '-10px'}}
                                    onClick={() => {
                                        let data = this.props.component.data;
                                        data.items.splice(index, 1);
                                        this.props.onChange('data', data);
                                    }}
                                />
                                <div>
                                    <label>Image</label>
                                    <div>
                                        <input
                                            type="text"
                                            value={item.image ? item.image : ''}
                                            onChange={event => {
                                                let data = this.props.component.data;
                                                let items = data.items;
                                                item.image = event.target.value;
                                                items[index] = item;
                                                data.items = items;
                                                this.props.onChange('data', data);
                                            }}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <label>Image alt</label>
                                    <div>
                                        <input
                                            type="text"
                                            value={item.image_alt ? item.image_alt : ''}
                                            onChange={event => {
                                                let data = this.props.component.data;
                                                let items = data.items;
                                                item.image_alt = event.target.value;
                                                items[index] = item;
                                                data.items = items;
                                                this.props.onChange('data', data);
                                            }}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <label>Description</label>
                                    <div>
                                        <textarea
                                            value={item.description ? item.description : ''}
                                            onChange={event => {
                                                let data = this.props.component.data;
                                                let items = data.items;
                                                item.description = event.target.value;
                                                items[index] = item;
                                                data.items = items;
                                                this.props.onChange('data', data);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}
